import { Component, Input, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { CompanyService } from 'src/app/services/core/company/company.service';
import { TripService } from 'src/app/services/core/distributions/trip/trip.service';
import { FundingSourceService } from 'src/app/services/core/funding-source/funding-source.service';
import { LosService } from 'src/app/services/core/levelOfService/los.service';
import { MemberService } from 'src/app/services/core/member/member.service';
import { SpaceTypeService } from 'src/app/services/core/spaceTypes/space-type.service';
import { CsvService } from 'src/app/services/csv-service/csv.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
import * as moment from 'moment-timezone';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import { StatisticsService } from 'src/app/services/core/statistics/statistics.service';

@UntilDestroy()
@Component({
  selector: 'app-partnerpay-list',
  templateUrl: './partnerpay-list.component.html',
  styleUrls: ['./partnerpay-list.component.css']
})
export class PartnerpayListComponent implements OnInit {
  search: any
  trips: any;
  user: any;
  levelOfServices: any
  prelevelOfServices: any = {}
  preAppointmentTypes: any = {}
  selectedCompany:any = '';
  currentPage = 1;
  // preMembers: any = {};
  preFundingSource: any = {}
  isDropdownOpen = false;
  fundingSource: any;
  preSpaceTypeList: any;
  preCompanies: any
  totalPages = 0;
  selectedFundingSource: any = '';
  totalResults = 0;
  allCompanies: any;
  numberOfRecords = NUMBER_OF_RECORDS;
  todayDate:any = [];
  overviewData:any = {};
  source = 'original'
  
   constructor(
     private memberService : MemberService,
     private levelOfService: LosService,
     private spaceType: SpaceTypeService,
     private fundingSourceService: FundingSourceService,
     private credentialService: CredentialService,
     private statService: StatisticsService,
     private csvService: CsvService,
     private sharedDataService: SharedDataService,
   ) { }
 
  ngOnInit(): void {

    this.getFundingSources()
    this.getAllCompanies()
    this.getUser();
  }

  getUser() {
    this.sharedDataService.getUser().pipe(untilDestroyed(this)).subscribe((data) => {
      if (data) {
        this.user = data;
        this.todayDate = [
          moment().tz(this.user.timeZone).startOf("day"),
          moment().tz(this.user.timeZone).endOf("day"),
        ];
        this.getAllTrips();
      }

    })
  }


getAllTrips() {
  const queryparams: any = {
    time: [this.todayDate[0].toISOString(), this.todayDate[1].toISOString()],
    source: this.source
  };

   if (this.selectedCompany && this.selectedCompany.id) {
    queryparams.company = this.selectedCompany.id; 
  }

  if (this.selectedFundingSource && this.selectedFundingSource.id) {
    queryparams.fundingsource = this.selectedFundingSource.id;
  }


  this.statService.getPrivatePayReport(queryparams).pipe(untilDestroyed(this))
    .subscribe((result: any) => {
      if (result) {
        const [{ data, ...kpiData }] = result;
        this.trips = data;
        this.overviewData = kpiData.overview
      }
    });
}

  closeFilterDropDown(evt:any) {
    this.isDropdownOpen = false
  }
   toggleDropdown(event: MouseEvent) {
    this.isDropdownOpen = !this.isDropdownOpen;
  }
  getFundingSources() {
    const queryParams = {
      limit: 9999,
      isActive: true
    };
    this.fundingSourceService
      .getPicker(queryParams).pipe(untilDestroyed(this))
      .subscribe((data: any) => {
        if (data && data.results) {
          this.fundingSource = data.results.sort((a: any, b: any) =>
            (a.title).toLowerCase().localeCompare((b.title).toLowerCase())
          );
          this.preFundingSource = this.fundingSource.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }
      });
  }
 
  getLevelOfService() {
    const queryParams = {
      limit: 9999,
      isActive: true
    };
    this.levelOfService.getPicker(queryParams).pipe(untilDestroyed(this))
      .subscribe((data: any) => {
        if (data && data.results) {
          this.levelOfServices = data.results;
          this.prelevelOfServices = this.levelOfServices.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }
      })
  }
 
  getSpaceTypes() {
    const queryParams = {
      limit: 9999,
      isActive: true
    };
    this.spaceType.getPicker(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results) {
        this.preSpaceTypeList = data.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
      }
    })
  }

   getAllCompanies() {
     const queryParams = {
       limit: 9999,
       isActive: true
     };
    this.credentialService.getPicker(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results) {
        this.allCompanies = data.results;
        this.preCompanies = data.results.reduce((obj: any, item: any) => ((obj[item.id] = item), obj), {});
      }
    });
  }

  filterFundingsourceBySelection() {
    this.selectedCompany = '';
    this.getAllTrips();
  }

partnerPayReport(type:string="all") {
  const queryparams: any = {
    limit: 9999, 
    page: 1,
    time: [this.todayDate[0].toISOString(), this.todayDate[1].toISOString()],
    source: this.source,
  };

  if (this.selectedCompany && this.selectedCompany.id) {
    queryparams.company = this.selectedCompany.id;
  }
  if (this.selectedFundingSource && this.selectedFundingSource.id) {
    queryparams.fundingsource = this.selectedFundingSource.id;
  }

  this.statService.getPrivatePayReport(queryparams).pipe(untilDestroyed(this)).subscribe((result: any) => {
    if (result) {
      if (type === "company") {
        this.csvService.generatePrivateCompanyPayReport(
          result,
          this.todayDate,
        );
      } else if (type === "fundingSource") {
        this.csvService.generatePrivateFSPayReport(
          result,
          this.todayDate,
        );
      }
      else {
        this.csvService.generatePrivatePayReport(
          result,
          this.todayDate
        );
      }
    }
  });
}

  changeSource(tab: string) {
    this.source = tab;
    this.getAllTrips();
  }

  filterCompaniesBySelection() {
    this.selectedFundingSource = '';
    this.getAllTrips();
  }

  calculateTotalFare(tripFare:any, offeredFare:any){
    const finalFare = tripFare - offeredFare
    return finalFare.toFixed(2)
  }

  onDateChange(event: any) {
    this.todayDate = [
      event[0],
      event[1].endOf("day"),
    ];
    this.getAllTrips();
  }

   onPageChange(page: number) {
    this.currentPage = page;
    this.getAllTrips();
  }
}
